import { useEffect, useState, type ReactElement } from 'react';
import { emberApi, apiFailureReason } from '../api';
import { AgeCheckQuestion } from '../components/AgeCheck';
import { MinorNotice } from '../components/MinorNotice';
import { Link } from '../components/Link';
import { trackFailed } from '../../../../../shared-web/track';

/**
 * /age — the age check's question on a page of its own (edge age-check.js, 2026-10-27 founder): the link the text door
 * is sent with Ember's question, signed in by its /r/ link. The same question the thread draws; once answered 18 or
 * older, Ember answers what they said while it waited, where they said it.
 */
export function AgeCheckPage(): ReactElement {
  const [state, setState] = useState<'loading' | 'ask' | 'none' | 'stopped' | 'adult'>('loading');

  useEffect(() => {
    let live = true;
    emberApi.ageCheck()
      .then((r) => { if (live) setState(r.stopped ? 'stopped' : r.age_check ? 'ask' : 'none'); })
      .catch((err) => { if (live) { trackFailed('age_check_answer', apiFailureReason(err)); setState('none'); } });
    return () => { live = false; };
  }, []);

  // Answered under 18 here, or a browser already stopped: the minor notice, on its own reading column.
  if (state === 'stopped') return <div className="ember-container"><MinorNotice /></div>;
  return (
    <div className="ember-container ember-page-quiet">
      {state === 'ask' && <AgeCheckQuestion onAnswered={(answer) => setState(answer === 'adult' ? 'adult' : 'stopped')} />}
      {state === 'adult' && (
        <div className="knock-card is-closed" role="status">
          <p className="knock-lede">Thank you. Ember will pick up where you left off.</p>
          <p className="knock-more-doors"><Link to="/talk?mode=chat" className="knock-more-door">Back to the conversation</Link></p>
        </div>
      )}
      {state === 'none' && (
        <div className="knock-card is-closed">
          <p className="knock-lede">There's nothing to answer here.</p>
          <p className="knock-more-doors"><Link to="/talk?mode=chat" className="knock-more-door">Go to your conversation</Link></p>
        </div>
      )}
    </div>
  );
}
